<div class="pull-left company-picker" (click)="showAccountSelectModal()">
  @if (model.selectedCompany) {
    <a id="changeCompany">{{model.selectedCompany.name}}</a>
  }
</div>
<app-company-picker-modal [IsModal]="true" [DisplayList]="true"></app-company-picker-modal>
